module.exports = __webpack_public_path__ + "img/shape_circle--black.2448de0.webp";